import { HttpParams } from '@angular/common/http';

/** Representa o filtro de pesquisa dos motivos de perdas */
export class MotivoPerdaVendaSearchFilter {
    filterPsq: string;
    situacao: number;
    perdaVenda: boolean;
    clienteCongelado: boolean;
    contatoCliente: boolean;
    revisaoPedidoOrcamento: boolean;
    /** Usos do catálogo que o motivo atende; o recorte combina por OU. */
    contextos: string[];

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        // Perda de Venda
        if (this.perdaVenda != null && this.perdaVenda !== undefined) {
            params = params.append('perdaVenda', this.perdaVenda.toString());
        }

        // Cliente Congelado
        if (this.clienteCongelado != null && this.clienteCongelado !== undefined) {
            params = params.append('clienteCongelado', this.clienteCongelado.toString());
        }

        // Contato de Cliente
        if (this.contatoCliente != null && this.contatoCliente !== undefined) {
            params = params.append('contatoCliente', this.contatoCliente.toString());
        }

        // Revisão de Pedidos/Orçamentos
        if (this.revisaoPedidoOrcamento != null && this.revisaoPedidoOrcamento !== undefined) {
            params = params.append('revisaoPedidoOrcamento', this.revisaoPedidoOrcamento.toString());
        }

        // Contextos de uso: repetidos na query, um por valor
        if (this.contextos?.length) {
            this.contextos.forEach((contexto) => {
                params = params.append('contextos', contexto);
            });
        }

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.situacao = null;
        this.perdaVenda = null;
        this.clienteCongelado = null;
        this.contatoCliente = null;
        this.revisaoPedidoOrcamento = null;
        this.contextos = null;
    }
}

